import React from 'react';
import Icon from './icon';

interface IconToggleProps {
    onIcon: string;
    offIcon: string;
    size: number;
    onColor?: string;
    offColor?: string;
    checked: boolean;
    onChange: (value: boolean) => void;
    className?: string;
    disabled?: boolean;
}

const IconToggle: React.FC<IconToggleProps> = ({
    onIcon,
    offIcon,
    size,
    checked,
    onChange,
    className = '',
    disabled = false,
}) => {
    const handleClick = () => {
        if (!disabled) {
            onChange(!checked);
        }
    };

    return (
        <button
            type="button"
            className={`icon-toggle grayscale-800 ${checked ? 'checked' : ''} ${className} ${disabled ? 'disabled' : ''}`}
            onClick={handleClick}
            disabled={disabled}
        >
            <span className="icon-toggle-state">
                <Icon
                    name={offIcon}
                    size={size}
                    color={!checked ? "grayscale-1200" : "grayscale-500"}
                />
            </span>
            <span className="icon-toggle-state">
                <Icon
                    name={onIcon}
                    size={size}
                    color={checked ? "grayscale-1200" : "grayscale-500"}
                />
            </span>
        </button>
    );
};

export default IconToggle;